const keys = {
  SEGURO_NAO_PERMITE: {
    key: 'SEGURO_NAO_PERMITE',
    description: 'Seguradora não permite este tipo de carga',
  },
  SEM_FROTA_DISPONIVEL: {
    key: 'SEM_FROTA_DISPONIVEL',
    description: 'Sem frota disponível no momento',
  },
  OUTRA: {
    key: 'OUTRA',
    description: 'Outro motivo',
  },
};

const values = Object.keys(keys)
  .map((key) => keys[key]);

export default {
  keys,
  values,
};
